export function sellerWarningEquitySkimming2027() {
return [   // Release 2026-10-01 17:57:46
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 340.353,
   left: 205.92,
   width: 349.56,
   height: 13.287
}
,
{
   page: 0,
   name: "Buyers Legal Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 500.967,
   left: 212.4,
   width: 345.72,
   height: 12.633
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 587.182,
   left: 68.4,
   width: 470.76,
   height: 11.978
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 388.538,
   left: 229.299,
   width: 326.384,
   height: 10.515
}
] }
